<template>
  <main class="flex-1 relative overflow-y-auto focus:outline-none" tabindex="0">
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8 ">
      <div class="md:flex md:items-center md:justify-between">
        <div class="flex min-w-0">
          <svg-vue class="content-title-icon" icon="font-awesome.cog-duotone"></svg-vue>
          <h1 class="content-title">
            {{ $t('Welcome to workshop') }}
          </h1>
        </div>
      </div>
    </div>

    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8 ">
      <div class="my-6">
        <ul class="grid grid-cols-2 gap-4">
          <router-link class="col-span-1 flex flex-col text-center cursor-pointer bg-white rounded-lg shadow" tag="li" to="/workshop/repairable-list">
            <div class="flex-1 flex flex-col p-5">
              <div class="flex-shrink-0 mx-auto">
                <svg-vue class="block-link-icon" icon="font-awesome.tasks-regular"></svg-vue>
              </div>
              <h3 class="form-description-head">
                {{ $t('Repairable orders') }}
              </h3>
              <p class="form-description-text">
                {{ $t('Repair orders that were assigned to me') }}
              </p>
            </div>
          </router-link>
          <router-link class="col-span-1 flex flex-col text-center cursor-pointer bg-white rounded-lg shadow" tag="li" to="/workshop/add-repair">
            <div class="flex-1 flex flex-col p-5">
              <div class="flex-shrink-0 mx-auto">
                <svg-vue class="block-link-icon" icon="font-awesome.tools-solid"></svg-vue>
              </div>
              <h3 class="form-description-head">
                {{ $t('Create standard repair invoice') }}
              </h3>
              <p class="form-description-text">
                {{ $t('Create new repair order by using predefined devices and services') }}
              </p>
            </div>
          </router-link>
          <router-link class="col-span-1 flex flex-col text-center cursor-pointer bg-white rounded-lg shadow" tag="li" to="/workshop/track-repair">
            <div class="flex-1 flex flex-col p-5">
              <div class="flex-shrink-0 mx-auto">
                <svg-vue class="block-link-icon" icon="font-awesome.search-solid"></svg-vue>
              </div>
              <h3 class="form-description-head">
                {{ $t('Track repair status') }}
              </h3>
              <p class="form-description-text">
                {{ $t('Track your repair current status and progress') }}
              </p>
            </div>
          </router-link>
          <router-link
            class="col-span-1 flex flex-col text-center cursor-pointer bg-white rounded-lg shadow"
            tag="li"
            to="/workshop/add-repair-manually"
          >
            <div class="flex-1 flex flex-col p-5">
              <div class="flex-shrink-0 mx-auto">
                <svg-vue class="block-link-icon" icon="font-awesome.plus-circle-solid"></svg-vue>
              </div>
              <h3 class="form-description-head">
                {{ $t('Create custom repair invoice') }}
              </h3>
              <p class="form-description-text">
                {{ $t('Create new repair order by filling up whole information manually') }}
              </p>
            </div>
          </router-link>
        </ul>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: 'index',
};
</script>
